import React from 'react';

/** The panel's one container. A titled box with optional right-hand actions. */
export function Card({ title, hint, actions, children, className = '', bodyClassName = 'p-4' }) {
  return (
    <section className={`overflow-hidden rounded-xl border border-hairline bg-surface shadow-sm ${className}`}>
      {(title || actions) && (
        <header className="flex flex-wrap items-center justify-between gap-2 border-b border-hairline px-4 py-3">
          <div className="min-w-0">
            {title && <h2 className="text-sm font-semibold text-ink">{title}</h2>}
            {hint && <p className="mt-0.5 text-xs text-ink-muted">{hint}</p>}
          </div>
          {actions && <div className="flex flex-shrink-0 items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}

/** A labelled group of cards/tiles. Used to bundle a page into readable bands. */
export function Band({ title, actions, children, className = '' }) {
  return (
    <section className={`mb-8 ${className}`}>
      {(title || actions) && (
        <div className="mb-3 flex items-center justify-between gap-2">
          {title && (
            <h2 className="text-xs font-semibold uppercase tracking-wide text-ink-muted">{title}</h2>
          )}
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}

/** Label/value pair for detail pages. Values wrap; labels never do. */
export function Field({ label, children, mono = false }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs font-medium text-ink-muted">{label}</dt>
      <dd className={`mt-0.5 break-words text-sm text-ink ${mono ? 'font-mono text-xs' : ''}`}>
        {children == null || children === '' ? <span className="text-ink-muted">-</span> : children}
      </dd>
    </div>
  );
}

export default Card;
